import { Box, Tooltip, TooltipProps } from "@mui/material";

import { LockIcon } from "lucide-react";

export function TooltipWithLock({ ...props }: TooltipProps) {
  return (
    <Tooltip
      placement="top"
      title={
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <LockIcon />
          <Box sx={{ paddingTop: "3px" }}> {props.title}</Box>{" "}
        </Box>
      }
    >
      {props.children}
    </Tooltip>
  );
}
